// Room member projection shared by `room.welcome` and `room.resume-ok`.
// (protocol-events.md §2.3 / §2.8)
import { z } from 'zod';
import { MAX_DISPLAY_NAME_LENGTH, MIN_DISPLAY_NAME_LENGTH } from '../constants.js';
import { customCursorSchema } from './cursor.js';
/**
 * Slimmed-down view of a member as exposed to other clients.
 *
 * `permissions` is intentionally NOT included here for MVP — see
 * protocol-events.md §2.11 「(要検証) members[] に permissions を含めて他人に
 * 見せるか」.
 *
 * `cursor` (custom-cursor-2026-09-19.md §2.3): the member's confirmed custom
 * cursor, `null` when unset. `optional()` alongside `nullable()` so older
 * servers that omit the field entirely don't break newer clients — new
 * servers always send either `null` or a `CustomCursor` object, never
 * `undefined`. Draft (in-progress editing) state is NOT included here — see
 * `member.cursor-draft` / `member.cursor-drafted` in `events/member.ts`.
 */
export const roomMemberSchema = z.object({
    uid: z.string(),
    displayName: z.string().min(MIN_DISPLAY_NAME_LENGTH).max(MAX_DISPLAY_NAME_LENGTH),
    isRom: z.boolean(),
    cursor: customCursorSchema.nullable().optional(),
});
//# sourceMappingURL=member.js.map